import { useCallback } from "react";
import styled from "@emotion/styled";
import { MemCommonMarkdown } from "@mem-labs/common-editor";
import type { FC } from "react";
import { SmartCardSection } from "@/components/heads-up/cards/common/layout";
import { CollapsibleSectionHeader } from "@/components/heads-up/cards/common/collapsible-section-header";
import { MarkdownSmartCard } from "@/components/heads-up/heads-up.types";
import type { INoteObservable } from "@/store/note/types";
import type { Maybe } from "@/domains/common/types";

type Props = {
  card: MarkdownSmartCard;
  getNoteObservable?: (noteId: string) => Maybe<INoteObservable>;
};

export const MarkdownSmartCardRenderer: FC<Props> = ({ card }) => {
  const title = card.value.title;
  const markdown = card.value.markdown;

  const handleClick = useCallback(() => {
    /** no-op for now. */
  }, []);

  if (!markdown) return null;

  return (
    <SmartCardSection>
      <CollapsibleSectionHeader title={title}>
        <MarkdownContent onClickMemItem={handleClick}>{markdown}</MarkdownContent>
      </CollapsibleSectionHeader>
    </SmartCardSection>
  );
};

const MarkdownContent = styled(MemCommonMarkdown)`
  font-size: ${({ theme }) => theme.fontSizes["text-s"]};
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-top: ${({ theme }) => theme.spacing["2"]};
  margin-left: ${({ theme }) => theme.spacing["3"]};
`;
